module.exports = __webpack_public_path__ + "img/tablet-acaiteria.e59ead24.webp";